import { handleActions } from 'redux-actions'
import {
  storeKeys,
  unlockPrivateKeyStart,
  unlockPrivateKeySuccess,
  unlockPrivateKeyWrongPassword
} from './actions'
import { signupSuccess } from '../signup/actions'
import { firebaseSignout } from '../signin/actions'

const defaultState = {
  keys: {},
  keyPassword: null,
  keyPasswordAttempt: null,
  unlockPending: false
}

export default handleActions(
  {
    [storeKeys]: (state, { payload: { privKey, pubKey, keyPassword } }) => ({
      ...state,
      keys: { private: privKey, public: pubKey },
      keyPassword
    }),
    [unlockPrivateKeyStart]: (state, { payload: keyPassword }) => ({
      ...state,
      keyPasswordAttempt: keyPassword,
      unlockPending: true
    }),
    [unlockPrivateKeySuccess]: (state, { payload: keyPassword }) => ({
      ...state,
      keyPassword,
      wrongPassword: false,
      unlockPending: false
    }),
    [unlockPrivateKeyWrongPassword]: state => ({
      ...state,
      wrongPassword: true,
      unlockPending: false
    }),
    [signupSuccess]: (state, { payload: { privKey, pubKey } }) => ({
      ...state,
      keys: { private: privKey, public: pubKey }
    }),
    [firebaseSignout]: () => defaultState
  },
  defaultState
)



// WEBPACK FOOTER //
// ./src/services/crypto/reducer.js